import { useTranslation } from 'react-i18next';

const TRUSTPILOT_URL = "https://ca.trustpilot.com/review/mysterymaker.party";

const TrustpilotBadge = () => {
  const { t } = useTranslation();

  return (
    <a
      href={TRUSTPILOT_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 sm:gap-x-4 py-3 no-underline transition-opacity hover:opacity-80"
      aria-label={t('trustpilot.ariaLabel')}
    >
      <span className="text-sm sm:text-base font-inter" style={{ color: 'var(--color-cream-muted)' }}>
        {t('trustpilot.customersSay')}
      </span>

      <span className="text-lg sm:text-xl font-bold font-inter" style={{ color: 'var(--color-cream)' }}>
        {t('trustpilot.excellent')}
      </span>

      <img
        src="/images/trustpilot-stars.png"
        alt={t('ui.stars5')}
        className="h-7 sm:h-8 w-auto"
      />

      <img
        src="/images/trustpilot-logo.svg"
        alt="Trustpilot"
        className="h-6 sm:h-7 w-auto"
      />
    </a>
  );
};

export default TrustpilotBadge;
